import {Component, ElementRef, EventEmitter, HostListener, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChanges, ViewChild} from "@angular/core";

@Component({
    selector: 'sticky-on-scroll-panel',
    templateUrl: './sticky-on-scroll-panel.template.html',
    styleUrls: ['./style.scss'],
    standalone: false
})
export class StickyOnScrollPanelComponent implements OnInit, OnChanges, OnDestroy {

	@Input() stickyAfterScrollThreshold: number;
	@Input() stickyEnabled: boolean;
	@Output() stickToBottomChanged: EventEmitter<boolean> = new EventEmitter();
	@ViewChild('stickyWrapper', {static: false}) stickyWrapper: ElementRef<HTMLElement>;
	stickToBottom: boolean;
	private footer: Element;
	bottomOffset: number = 0;
	private documentHeightChanged$: EventEmitter<any> = new EventEmitter();

	@HostListener('window:scroll', [])
	onPageScroll() {
		if (this.stickyEnabled && window.screen.width <= 1400) {
			const verticalOffset = window.pageYOffset
				|| document.documentElement.scrollTop
				|| document.body.scrollTop || 0;

			this.stickToBottom = verticalOffset >= this.stickyAfterScrollThreshold;
			this.stickToBottomChanged.emit(this.stickToBottom);
			const documentHeight: number = this.getDocumentHeight();
			this.adjustStickyPanelPosition(documentHeight);
		}
	}

	ngOnInit(): void {
		this.footer = document.getElementsByClassName('umbrella-footer').item(0);
		this.documentHeightChanged$.subscribe(() => this.onPageScroll());
		this.onElementHeightChange(document.body, () => this.documentHeightChanged$.next({}));
	}

	ngOnChanges(changes: SimpleChanges): void {
		if (changes['stickyEnabled'] && changes['stickyEnabled'].previousValue != null && changes['stickyEnabled'].previousValue != changes['stickyEnabled'].currentValue) {
			if (!this.stickyEnabled) {
				this.stickToBottom = false;
				this.stickToBottomChanged.emit(this.stickToBottom);
			} else {
				this.onPageScroll();
			}
		}
	}

	ngOnDestroy(): void {
		this.stickToBottom = false;
		this.adjustStickyPanelPosition();
		clearTimeout((document.body as any).onElementHeightChangeTimer);
	}

	private adjustStickyPanelPosition(documentHeight?: number) {
		if (documentHeight == null) {
			this.adjustStickyPanelPosition(this.getDocumentHeight());
		}

		if (this.overlapsFooter(documentHeight)) {
			this.bottomOffset = (window.scrollY - documentHeight + window.innerHeight + this.footer.clientHeight) - 80;
		} else {
			this.bottomOffset = -80;
		}
	}

	private overlapsFooter(documentHeight: number) {
		return window.scrollY >= documentHeight - window.innerHeight - this.footer.clientHeight;
	}

	private getDocumentHeight(): number {
		const body = document.body;
		const html = document.documentElement;
		return Math.max(body.scrollHeight, body.offsetHeight, html.clientHeight, html.scrollHeight, html.offsetHeight);
	}

	private onElementHeightChange(element, callback: () => void) {
		let lastHeight: number = element.clientHeight;
		let newHeight: number;

		(function run() {
			newHeight = element.clientHeight;
			if (lastHeight !== newHeight) {
				callback();
			}

			lastHeight = newHeight;

			if (element.onElementHeightChangeTimer) {
				clearTimeout(element.onElementHeightChangeTimer);
			}

			element.onElementHeightChangeTimer = setTimeout(run, 200);
		})();
	}
}
